module.exports = __webpack_public_path__ + "static/media/us.4c3d08c6.svg";